import React from 'react';
import styles from './UIGameHelpButtons.module.scss';
import { UIGameHelpFullScreenButton } from './UIGameHelpFullScreenButton/index.ts';
import { UIGameHelpInformationButton } from './UIGameHelpInformationButton/index.ts';
import { UIGameHelpRulesButton } from './UIGameHelpRulesButton/index.ts';
import { UIGameHelpRushIntroButton } from './UIGameHelpRushIntroButton/UIGameHelpRushIntroButton.tsx';
import { UIGameHelpUserSettingsButton } from './UIGameHelpUserSettingsButton/index.ts';
import { UIGameHelpRulesButtonProvider } from './UIGameHelpRulesButton/UIGameHelpRulesButtonContext.tsx';
import { UIGameFullScreenProvider } from './UIGameHelpFullScreenButton/UIGameHelpFullScreenContext.tsx';
import { UIGameHelpLeaveGameProvider } from './UIGameHelpLeaveGameContext.tsx';
import { ModeSettingEnum } from '@colonist/types';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { useRequestPause } from '../../hooks/usePause.ts';
import { StorageWrapper } from '../../utils/storage.ts';
import clsx from 'clsx';
export const UIGameHelpUserSettingsButtonContainer = ({ isRulesOptionVisible, initialCanResign, className })=>{
    const requestPause = useRequestPause();
    const { sendDisableKarma } = useGameStore((state)=>state.gameSendEvent);
    const setIsOpenSettings = useGameStore((state)=>state.gameUserSettings.setIsOpenSettings);
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    const sendMobilePausedGameAnalytics = useGameStore((state)=>state.gameAnalytics.sendMobilePausedGameAnalytics);
    const onPauseGameClick = ()=>{
        sendMobilePausedGameAnalytics();
        requestPause();
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.settingsButtonContainer
    }, /*#__PURE__*/ React.createElement(UIGameHelpRulesButtonProvider, null, /*#__PURE__*/ React.createElement(UIGameHelpLeaveGameProvider, {
        initialCanResign: initialCanResign
    }, /*#__PURE__*/ React.createElement(UIGameHelpUserSettingsButton, {
        className: className,
        isPlayerSpectator: isMyColorSpectator,
        isRulesOptionVisible: isRulesOptionVisible,
        onSettingsClick: ()=>setIsOpenSettings(true),
        onPauseGameClick: onPauseGameClick,
        onDisableKarmaClick: sendDisableKarma
    })))));
};
export const UIGameHelpButtons = ({ initialCanResign, className })=>{
    const shouldHideFullScreenButton = useGameStore((state)=>state.gameClientConfig.shouldHideFullScreenButton);
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const isMechanicIslandExplorationActive = useGameStore((state)=>state.gameState.mechanicIslandExplorationState) !== undefined;
    const victoryPointsToWin = useGameStore((state)=>state.gameSettings.victoryPointsToWin);
    const myColor = useGameStore((state)=>state.myColor);
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P;
    const rushGamesPlayed = StorageWrapper.getRushGamesPlayed();
    const sendInGameInfoWindowViewedAnalytics = useGameStore((state)=>state.gameAnalytics.sendInGameInfoWindowViewedAnalytics);
    const sendInGameInfoWindowClosedAnalytics = useGameStore((state)=>state.gameAnalytics.sendInGameInfoWindowClosedAnalytics);
    const sendInGameInfoWindowTabChangedAnalytics = useGameStore((state)=>state.gameAnalytics.sendInGameInfoWindowTabChangedAnalytics);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, /*#__PURE__*/ React.createElement(UIGameHelpUserSettingsButtonContainer, {
        initialCanResign: initialCanResign,
        isRulesOptionVisible: false
    }), !isBeginnerMode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UIGameHelpRulesButtonProvider, null, /*#__PURE__*/ React.createElement(UIGameHelpRulesButton, null)), shouldHideFullScreenButton == false && /*#__PURE__*/ React.createElement(UIGameFullScreenProvider, null, /*#__PURE__*/ React.createElement(UIGameHelpFullScreenButton, null)), /*#__PURE__*/ React.createElement(UIGameHelpInformationButton, {
        isDismissibleByOutsideClick: false,
        gameMode: modeSetting,
        isMechanicIslandExplorationActive: isMechanicIslandExplorationActive,
        playerColor: myColor,
        victoryPointsToWin: victoryPointsToWin,
        onInfoWindowViewed: sendInGameInfoWindowViewedAnalytics,
        onInfoWindowClosed: sendInGameInfoWindowClosedAnalytics,
        onInfoWindowTabChanged: sendInGameInfoWindowTabChangedAnalytics
    }), /*#__PURE__*/ React.createElement(UIGameHelpRushIntroButton, {
        rushGamesPlayed: rushGamesPlayed
    })));
};
